// DesignConfig を YAML へ直列化し、コピー/ダウンロードを提供する。
// テンプレートの fields を辿って意味づけごとに整形する(画像 data URL は値を出さない)。

import { dump } from "js-yaml";
import { FONT_STACKS, type DesignConfig, type FontKind } from "./design";
import { TEMPLATES } from "./templates";
import { resolveValues } from "./templates/shared";

/** 生 values をそのまま出さず、group ごとに整形して YAML 文字列を返す。 */
export function toYaml(c: DesignConfig): string {
  const def = TEMPLATES[c.template];
  const v = resolveValues(def, c.values);

  const colors: Record<string, string> = {};
  const typography: Record<string, string> = {};
  const content: Record<string, string> = {};
  const images: Record<string, string> = {};

  for (const f of def.fields) {
    switch (f.kind) {
      case "color":
        colors[f.key] = v[f.key] ?? "";
        break;
      case "font":
        typography.font = v[f.key] ?? "";
        typography.fontFamily = FONT_STACKS[v[f.key] as FontKind] ?? "";
        break;
      case "text":
      case "textarea":
        content[f.key] = v[f.key] ?? "";
        break;
      case "image":
        // data URL は巨大なので値は出さず、設定有無だけを残す。
        images[f.key] = v[f.key] ? "設定済み" : "未設定";
        break;
    }
  }

  const doc = {
    version: 1,
    template: c.template,
    colors,
    typography,
    content,
    images,
  };
  return dump(doc, {
    indent: 2,
    lineWidth: -1, // 長い font-family を折り返さない
    noRefs: true,
    sortKeys: false, // 定義順を保持
  });
}

/** クリップボードへコピー。成功可否を boolean で返す。 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** 任意のテキストを指定ファイル名・MIME でダウンロードさせる。 */
export function downloadText(
  text: string,
  filename: string,
  mime = "text/plain",
): void {
  const blob = new Blob([text], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
